import api from './api';

export interface ContactRequest {
    id: number;
    public_id: string;
    name: string;
    last_name?: string | null;
    email: string;
    subject?: string | null;
    message: string;
    indicative?: string | null;
    number?: string | null;
    created_at: string;
    status: 'new' | 'read' | 'closed';
    source?: string | null;
}

export interface ContactRequestCreate {
    name: string;
    last_name?: string;
    email: string;
    subject?: string;
    message: string;
    indicative?: string;
    number?: string;
    source?: string;
}

export interface ContactRequestResponse {
    success: boolean;
    message?: string;
    error?: string;
    data?: ContactRequest;
    items?: ContactRequest[];
    total?: number;
}

class ContactRequestService {
    async create(contactRequest: ContactRequestCreate): Promise<ContactRequestResponse> {
        try {
            const response = await api.post<ContactRequestResponse>('/api/contact-requests', contactRequest);
            return response;
        } catch (error: any) {
            console.error('Error creating contact request:', error);
            throw error;
        }
    }

    async getAll(status?: string): Promise<ContactRequest[]> {
        try {
            const url = status ? `/api/contact-requests?status=${status}` : '/api/contact-requests';
            const response = await api.get<ContactRequestResponse>(url);
            return response.items || [];
        } catch (error: any) {
            console.error('Error fetching contact requests:', error);
            throw error;
        }
    }

    async getById(id: number): Promise<ContactRequest> {
        try {
            const response = await api.get<ContactRequestResponse>(`/api/contact-requests/${id}`);
            if (!response.data) {
                throw new Error('Contact request not found');
            }
            return response.data;
        } catch (error: any) {
            console.error('Error fetching contact request:', error);
            throw error;
        }
    }

    async updateStatus(id: number, status: 'new' | 'read' | 'closed'): Promise<ContactRequestResponse> {
        try {
            const response = await api.patch<ContactRequestResponse>(`/api/contact-requests/${id}/status`, { status });
            return response;
        } catch (error: any) {
            console.error('Error updating contact request status:', error);
            throw error;
        }
    }

    async delete(id: number): Promise<ContactRequestResponse> {
        try {
            const response = await api.delete<ContactRequestResponse>(`/api/contact-requests/${id}`);
            return response;
        } catch (error: any) {
            console.error('Error deleting contact request:', error);
            throw error;
        }
    }
}

export default new ContactRequestService();
